const RequestUtil = {
	/**
	 * Takes a callTreeId and turns it into an object.
	 */
	makeCallTreeHeader: function (callTreeId: string): Record<string, any> {
		return {
			CallTreeId: callTreeId,
		};
	},

	/**
	 * Takes a QoS priority and turns it into an object.
	 */
	makePriorityHeader: function (priority: string): Record<string, any> {
		return {
			"x-qos-priority": priority,
		};
	},
	makeCallTreeHeaderWithPriority: function (callTreeId: string, priority: string): Record<string, any> {
		return { ...this.makeCallTreeHeader(callTreeId), ...this.makePriorityHeader(priority) };
	},
	buildQuery: function (query: Record<string, any>): string {
		return Object.keys(query ?? {})
			.map(key => {
				const value = query[key];

				if (value === undefined || value === null) {
					return null;
				}

				if (Array.isArray(value)) {
					if (value.length === 0) {
						return null;
					}

					return value
						.map(item => {
							if (item) {
								return key + "=" + encodeURIComponent(item);
							} else {
								return "";
							}
						})
						.join("&");
				}

				return key + "=" + encodeURIComponent(value);
			})
			.filter(entry => entry !== null)
			.join("&");
	},

	/**
	 * Adds a callback to all xhr responses.
	 */
	addXMLRequestCallback: function (callback: (...args: Array<any>) => any) {
		if (!callback) {
			throw new Error();
		}

		const oldSend = XMLHttpRequest.prototype.send;

		// override the native send()
		(XMLHttpRequest.prototype as any).send = function () {
			const oldOnReadyStateChange = this.onreadystatechange;

			this.onreadystatechange = function () {
				if (this.readyState === 4) {
					callback.call(this, arguments);
				}

				if (oldOnReadyStateChange) {
					oldOnReadyStateChange.apply(this, arguments);
				}
			};
			//@ts-expect-error: argument type incompatible
			oldSend.apply(this, arguments);
		};
	},

	/**
	 * sets / replaces url query param
	 *
	 * source: https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
	 */
	updateUrlParameter: function (uri: string, key: string, value: string): string {
		if (!uri) {
			return uri;
		}

		// remove the hash part before operating on the uri
		const i = uri.indexOf("#");
		const hash = i === -1 ? "" : uri.substr(i);
		let newUri = i === -1 ? uri : uri.substr(0, i);
		const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		const separator = newUri.includes("?") ? "&" : "?";

		if (!value) {
			// remove key-value pair if value is empty
			newUri = newUri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), "");

			if (newUri.slice(-1) === "?") {
				newUri = newUri.slice(0, -1);
			}

			// replace first occurrence of & by ? if no ? is present
			if (!newUri.includes("?")) {
				newUri = newUri.replace(/&/, "?");
			}
		} else if (newUri.match(re)) {
			newUri = newUri.replace(re, "$1" + key + "=" + value + "$2");
		} else {
			newUri = newUri + separator + key + "=" + value;
		}

		return newUri + hash;
	},
};
export default RequestUtil;
